export default {
  enabled: true,
  items: [
    // { name: ':id_organization', classIcon: 'mdi mdi-city', parent: '/organizations', parentId: 'id_organization', slug: 'organizations', },
    // { name: 'projects', classIcon: 'mdi mdi-rocket', parent: '/organizations', parentId: 'id_organization', url: '/projects', slug: 'projects', },
  ],
}
